import { environment } from '@environment';

export function buildUrlGoogleStoragePicture(image: string | undefined): string | undefined {
  return image ? `${environment.api.googleStorage}/${environment.wizbiiFiles}/${image}` : undefined;
}
